<template>
  <div
    class="_background-wrapper"
    :style="`background:url(${bgUrl});
            background-position:${bgPos};
            background-repeat:no-repeat;
            background-size:${bgSize};
            position:absolute;
            top:0;
            left:0;
            width:100%;
            height:100%;
            overflow:hidden;`"
  >
    <slot />
  </div>
</template>
<script>
export default {
  props: {
    bgArr: {
      type: Array
    },
    ow: {
      type: Number,
      default: 750
    },
    bgPos: {
      type: String,
      default: 'center top'
    },
    bgSize: {
      type: String,
      default: '100% auto'
    }
  },
  created() {
    let bgArr = this.bgArr;
    if (!bgArr || Object.prototype.toString.call(bgArr).indexOf('Array') < 0)
      return;
    let ow = this.ow || 750;
    let rate = window.innerWidth / window.innerHeight;

    bgArr.sort((item1, item2) => {
      return item2.height - item1.height;
    });

    // 根据当前设备的尺寸比例来选择应该使用的背景图
    for (let item of this.bgArr) {
      if (rate >= ow / item.height) {
        this.bgUrl = item.url;
      }
    }
    if (rate < ow / bgArr[0].height) {
      this.bgUrl = bgArr[0].url;
    }
  },
  data() {
    return {
      bgUrl: ''
    };
  }
};
</script>

